import InterviewPage from "../../components/employeer/interview";

const InterviewEmployerPage = () => {
  return <InterviewPage />;
};

export default InterviewEmployerPage;
